import { render } from "./HeaderSubsection.vue?vue&type=template&id=c52f0f3a"
import script from "./HeaderSubsection.vue?vue&type=script&lang=js"
export * from "./HeaderSubsection.vue?vue&type=script&lang=js"

import "./HeaderSubsection.vue?vue&type=style&index=0&id=c52f0f3a&lang=scss"

import exportComponent from "/Users/dt/Sites/vues/foggyrealm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__